import AppError from 'errors/app-error'

export default class UserExistsError extends AppError {
  constructor() {
    super()
    this.statusCode = 422
    this.message = 'A User with that email already exists.'
  }
}
